<template>
    <vx-card :title="$t('Material')">

        <vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="4" search :data="materials">

            <div slot="header" v-if="offerUser && status < 2">

                <vs-button color="primary" type="border" @click="activeNewMaterialPrompt = true">{{$t("Add")}}</vs-button>

            </div>

            <template slot="thead">
                <vs-th sort-key="name">{{$t("Name")}}</vs-th>
                <vs-th sort-key="unit">{{$t("Unit")}}</vs-th>
                <vs-th sort-key="quantity">{{$t("Quantity")}}</vs-th>
                <vs-th sort-key="branch_office_id">{{$t("BranchOffice")}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                    <vs-td :data="data[index].name">
                        {{ data[index].name }}
                    </vs-td>

                    <vs-td :data="data[index].unit">
                        {{data[index].unit }}
                    </vs-td>

                    <vs-td :data="data[index].quantity">
                        {{ data[index].quantity }}
                    </vs-td>

                    <vs-td :data="data[index].branch_office_id">
                        {{ branchOfficeMap[data[index].branch_office_id].title }}
                    </vs-td>

                </vs-tr>
                </tbody>
            </template>



        </vs-table>
        <vs-popup :title="$t('Add')" :active.sync="activeNewMaterialPrompt" style="z-index: 54000">
            <div>
                <p>{{$t("Name")}}</p>
                <vs-input class="w-full" v-model="addName"></vs-input>
                <p class="mt-6">{{$t("Unit")}}</p>
                <vs-select class="selectExample w-full" v-model="addUnit">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:$t('Meter'), name:$t('Meter')}, {id:$t('Piece'), name:$t('Piece')}]" />
                </vs-select>
                <p class="mt-6">{{$t("Quantity")}}</p>
                <vs-input class="w-full" v-model="addQuantity"></vs-input>
                <p class="mt-6">{{$t("BranchOffice")}}</p>
                <vs-select autocomplete class="selectExample w-full" v-model="addBranchOffice">
                    <vs-select-item :key="index" :value="item.id" :text="item.title" v-for="(item,index) in branchOffices" />
                </vs-select>
                <p class="mt-6">{{$t("Description")}}</p>
                <vs-textarea class="w-full" v-model="addDescription"></vs-textarea>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addMaterial">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('Edit')" :active.sync="activeEditMaterialPrompt" style="z-index: 54000">
            <div>
                <p>{{$t("Name")}}</p>
                <vs-input class="w-full" :disabled="!(this.offerUser && this.status < 2)" v-model="editName"></vs-input>
                <p class="mt-6">{{$t("Unit")}}</p>
                <vs-select class="selectExample w-full" v-model="editUnit" :disabled="!(this.offerUser && this.status < 2)">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:$t('Meter'), name:$t('Meter')}, {id:$t('Piece'), name:$t('Piece')}]" />
                </vs-select>
                <p class="mt-6">{{$t("Quantity")}}</p>
                <vs-input class="w-full" :disabled="!(this.offerUser && this.status < 2)" v-model="editQuantity"></vs-input>
                <p class="mt-6">{{$t("BranchOffice")}}</p>
                <vs-select autocomplete :disabled="!(this.offerUser && this.status < 2)" class="selectExample w-full" v-model="editBranchOffice">
                    <vs-select-item :key="index" :value="item.id" :text="item.title" v-for="(item,index) in branchOffices" />
                </vs-select>
                <p class="mt-6">{{$t("Description")}}</p>
                <vs-textarea v-if="(this.offerUser && this.status < 2)" v-model="editDescription"></vs-textarea>
                <p v-else style="white-space: pre-wrap;">{{editDescription}}</p>
                <vs-divider v-if="(this.offerUser && this.status < 2)"/>
                <vs-button v-if="(this.offerUser && this.status < 2)" color="success" type="border" class="mt-6; mr-1" @click="editMaterial">{{$t("Save")}}</vs-button>
                <vs-button v-if="(this.offerUser && this.status < 2)" style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeMaterial">{{$t("Delete")}}</vs-button>
            </div>
        </vs-popup>
    </vx-card>

</template>
<script>

    export default {
        props: {
            id: {
                type: Number,
                required: true
            },
            clientCompanyId: {
                type: Number,
                required: true
            },
            offerUser: {
                type: Boolean,
                required: true
            },
            status: {
                type: Number,
                required: false,
                default: 0
            }
        },
        data(){
            return {

                selected: {},

                materials: null,

                activeNewMaterialPrompt: false,
                activeEditMaterialPrompt: false,
                addName: '',
                addUnit: this.$t('Piece'),
                addQuantity: '',
                addBranchOffice: 0,
                addDescription: '',

                editName: '',
                editUnit: '',
                editQuantity: '',
                editBranchOffice: 0,
                editDescription: '',

                branchOffices: [],

            }
        },
        computed: {
          branchOfficeMap(){

              let branchMap = {};
              for(let x = 0; x < this.branchOffices.length; x++){
                  branchMap[this.branchOffices[x].id] = this.branchOffices[x];
              }

              return branchMap;

          }
        },
        methods: {
            handleSelected(tr){
                this.editName = tr.name;
                this.editUnit = tr.unit;
                this.editQuantity = tr.quantity;
                this.editBranchOffice = tr.branch_office_id;
                this.editDescription = tr.notes;
                this.activeEditMaterialPrompt = true;
            },
            updateBranchOffices(){
                const thisIns = this;
                this.$http.get('/api/v1/client/' + this.clientCompanyId + "/branch_offices")
                    .then(function (response) {
                        thisIns.branchOffices = response.data;
                        if(thisIns.branchOffices.length > 0) thisIns.addBranchOffice = thisIns.branchOffices[0].id;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            updateMaterials(){
                const thisIns = this;
                this.$http.get('/api/v1/offer/' + this.id + "/material")
                    .then(function (response) {
                        thisIns.materials = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addMaterial(){
                const thisIns = this;
                this.$http.post('/api/v1/offer/' + this.id + "/material", {
                    name: this.addName,
                    unit: this.addUnit,
                    quantity: Number(this.addQuantity),
                    branch_office_id: Number(this.addBranchOffice),
                    notes: this.addDescription
                })
                    .then(function () {
                        thisIns.updateMaterials();
                        thisIns.activeNewMaterialPrompt = false;
                        thisIns.addName = '';
                        thisIns.addQuantity = 1;
                        thisIns.addDescription = '';
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            editMaterial(){
                const thisIns = this;
                this.$http.put('/api/v1/offer/' + this.id + "/material/" + this.selected.id, {
                    name: this.editName,
                    unit: this.editUnit,
                    quantity: Number(this.editQuantity),
                    branch_office_id: Number(this.editBranchOffice),
                    notes: this.editDescription,
                })
                    .then(function () {
                        thisIns.updateMaterials();
                        thisIns.activeEditMaterialPrompt = false;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            removeMaterial(){
                const thisIns = this;
                this.$http.delete('/api/v1/offer/' + this.id + "/material/" + this.selected.id)
                    .then(function () {
                        thisIns.updateMaterials();
                        thisIns.activeEditMaterialPrompt = false;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            }
        },
        watch: {
            activeEditMaterialPrompt: function () {
                if(!this.activeEditMaterialPrompt){
                    this.selected = {}
                }
            }
        },
        created() {
            this.updateMaterials();
            this.updateBranchOffices();
        }
    }

</script>
